<script>
	import { getContext, onDestroy, onMount } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import { get_file_size } from '../../library/scripts/utils.js'
	import {
		storeData,
		storeSiteManagement,
		storeRemainingStorage,
		storeFeedback,
	} from '../../library/scripts/Store.svelte'
	import * as animateScroll from 'svelte-scrollto'
	import AdminMail from './AdminMail.svelte'
	import Shop from './shop/Shop.svelte'
	import Drinks from './restaurant/Drinks.svelte'
	import Food from './restaurant/Food.svelte'
	import Rooms from './guesthouse/Rooms.svelte'
	import Seasons from './guesthouse/Seasons.svelte'
	import Bookings from './guesthouse/Bookings.svelte'
	import Revenue from './guesthouse/Revenue.svelte'
	import ContactKybo from '../../components/ContactKybo.svelte'

	let visibleMenu = false

	const globals = getContext('globals')
	const fsL = globals.fsL
	const fsN = globals.fsN
	const fsS = globals.fsS
	const bg = globals.adminBgDark
	const bgLight = globals.bgLight
	const navHeight = globals.navHeight
	const colorMain = globals.adminColorMain
	const colorError = globals.colorError
	const icon = globals.icon
	const innerW = globals.devWidth

	//the tools for administrator
	let mailTool = false
	let prodTool = false
	let foodTool = false
	let drinksTool = false
	let roomTool = false

	let mail = false
	let products = false
	let food = false
	let drinks = false
	let rooms = false
	let season = false
	let bookings = false
	let revenue = false

	//color for the storage
	let colorStorage = globals.adminColorMain

	let storage = null
	//remaining storage
	const oldStorage = get_file_size()
	oldStorage.then((value) => {
		storeRemainingStorage.set(value)
		if (value < 25) colorStorage = colorError
	})

	const getStorage = storeRemainingStorage.subscribe((value) => {
		storage = value
	})

	//the config file
	let configFile
	const stoData = storeData.subscribe((value) => {
		if (value) {
			configFile = value
			if (configFile.business === 'Restaurant') {
				foodTool = true
				drinksTool = true
			}

			if (configFile.business === 'Online Shop') {
				prodTool = true
			}

			if (configFile.business === 'Guest House') {
				roomTool = true
				foodTool = true
				drinksTool = true
			}

			if (configFile.widgets.indexOf('mail-management') > -1) mailTool = true
		}
	})

	const open_hamburger = () => {
		visibleMenu = visibleMenu === true ? false : true
	}

	const contact_kybo = () => {
		mail = false
		food = false
		drinks = false
		products = false
		rooms = false
		season = false
		bookings = false
		visibleMenu = false
		storeFeedback.set(true)
	}

	const manage_mail = () => {
		mail = true
		food = false
		drinks = false
		products = false
		rooms = false
		season = false
		bookings = false
		visibleMenu = false
		storeFeedback.set(false)
	}

	const manage_foods = () => {
		mail = false
		food = true
		drinks = false
		products = false
		rooms = false
		season = false
		bookings = false
		visibleMenu = false
		storeFeedback.set(false)
	}

	const manage_drinks = () => {
		mail = false
		food = false
		drinks = true
		products = false
		rooms = false
		season = false
		bookings = false
		visibleMenu = false
		storeFeedback.set(false)
	}

	const manage_products = () => {
		mail = false
		food = false
		drinks = false
		products = true
		rooms = false
		season = false
		bookings = false
		visibleMenu = false
		storeFeedback.set(false)
	}

	const manage_rooms = () => {
		mail = false
		food = false
		drinks = false
		products = false
		rooms = true
		season = false
		bookings = false
		visibleMenu = false
		storeFeedback.set(false)
	}

	const set_seasons = () => {
		mail = false
		food = false
		drinks = false
		products = false
		rooms = false
		season = true
		bookings = false
		visibleMenu = false
		storeFeedback.set(false)
	}

	const manage_bookings = () => {
		mail = false
		food = false
		drinks = false
		products = false
		rooms = false
		season = false
		bookings = true
		visibleMenu = false
		storeFeedback.set(false)
	}

	const close_site_management = () => {
		mail = false
		food = false
		drinks = false
		products = false
		rooms = false
		season = false
		bookings = false
		visibleMenu = false
		storeSiteManagement.set(false)
		storeFeedback.set(false)
	}

	onMount(() => {
		document.querySelector('body').style.backgroundColor = 'black'
		animateScroll.scrollToTop()
	})

	onDestroy(() => {
		stoData
		getStorage
		sessionStorage.clear()
		document.querySelector('body').style.backgroundColor = configFile.body
	})
</script>

{#if configFile}
	<div class="container" use:styles={{ bg }}>
		<div class="admin" use:styles={{ fsL, bg, navHeight, colorMain }}>
			Administrator
			<div class="storage" use:styles={{ fsN, colorStorage }}>{storage} MB</div>
			{#if innerW < 650}
				<div style="display:flex;width:100%;justify-content:flex-end;margin-right:10px;">
					<div on:click={open_hamburger} on:keydown={open_hamburger} class="hamburger_icon" use:styles={{ icon }} />
				</div>
				{#if visibleMenu}
					<div transition:slide={{ duration: 1000 }} class="hamburger_menu" use:styles={{ fsS, navHeight, bgLight }}>
						<div
							class="hamburger_link"
							use:styles={{ fsS, colorMain }}
							on:click={contact_kybo}
							on:keydown={contact_kybo}
						>
							Contact Kybo
						</div>
						{#if mailTool}
							<div
								class="hamburger_link"
								use:styles={{ fsS, colorMain }}
								on:click={manage_mail}
								on:keydown={manage_mail}
							>
								Manage Mails
							</div>
						{/if}
						{#if foodTool}
							<div
								class="hamburger_link"
								use:styles={{ fsS, colorMain }}
								on:click={manage_foods}
								on:keydown={manage_foods}
							>
								Manage Foods
							</div>
						{/if}
						{#if drinksTool}
							<div
								class="hamburger_link"
								use:styles={{ fsS, colorMain }}
								on:click={manage_drinks}
								on:keydown={manage_drinks}
							>
								Manage Drinks
							</div>
						{/if}
						{#if prodTool}
							<div
								class="hamburger_link"
								use:styles={{ fsS, colorMain }}
								on:click={manage_products}
								on:keydown={manage_products}
							>
								Manage Products
							</div>
						{/if}
						{#if roomTool}
							<div
								class="hamburger_link"
								use:styles={{ fsS, colorMain }}
								on:click={manage_rooms}
								on:keydown={manage_rooms}
							>
								Manage Rooms
							</div>

							<div
								class="hamburger_link"
								use:styles={{ fsS, colorMain }}
								on:click={set_seasons}
								on:keydown={set_seasons}
							>
								Manage Seasons
							</div>

							<div
								class="hamburger_link"
								use:styles={{ fsS, colorMain }}
								on:click={manage_bookings}
								on:keydown={manage_bookings}
							>
								Manage Bookings
							</div>
						{/if}
						<div
							class="hamburger_link"
							use:styles={{ fsS, colorMain }}
							on:click={close_site_management}
							on:keydown={close_site_management}
						>
							close
						</div>
					</div>
				{/if}
			{/if}
		</div>

		{#if innerW > 650}
			<div class="admin_menu">
				<div class="admin_link" use:styles={{ fsN }} on:click={contact_kybo} on:keydown={contact_kybo}>
					Contact Kybo
				</div>
				{#if mailTool}
					<div class="admin_link" use:styles={{ fsN }} on:click={manage_mail} on:keydown={manage_mail}>
						Manage Mails
					</div>
				{/if}
				{#if foodTool}
					<div class="admin_link" use:styles={{ fsN }} on:click={manage_foods} on:keydown={manage_foods}>
						Manage Foods
					</div>
				{/if}
				{#if drinksTool}
					<div class="admin_link" use:styles={{ fsN }} on:click={manage_drinks} on:keydown={manage_drinks}>
						Manage Drinks
					</div>
				{/if}
				{#if prodTool}
					<div class="admin_link" use:styles={{ fsN }} on:click={manage_products} on:keydown={manage_products}>
						Manage Products
					</div>
				{/if}
				{#if roomTool}
					<div class="admin_link" use:styles={{ fsN }} on:click={manage_rooms} on:keydown={manage_rooms}>
						Manage Rooms
					</div>

					<div class="admin_link" use:styles={{ fsN }} on:click={set_seasons} on:keydown={set_seasons}>
						Manage Seasons
					</div>

					<div class="admin_link" use:styles={{ fsN }} on:click={manage_bookings} on:keydown={manage_bookings}>
						Manage Bookings
					</div>
				{/if}
				<div
					class="admin_link"
					use:styles={{ fsN }}
					on:click={close_site_management}
					on:keydown={close_site_management}
				>
					close
				</div>
			</div>
		{/if}

		{#if $storeFeedback}
			<div transition:slide={{ duration: 500, delay: 200 }}>
				<ContactKybo />
			</div>
		{/if}

		{#if mail}
			<div transition:slide={{ duration: 500, delay: 200 }}>
				<AdminMail />
			</div>
		{/if}

		{#if drinks}
			<div transition:slide={{ duration: 500, delay: 200 }}>
				<Drinks />
			</div>
		{/if}

		{#if food}
			<div transition:slide={{ duration: 500, delay: 200 }}>
				<Food />
			</div>
		{/if}

		{#if products}
			<div transition:slide={{ duration: 500, delay: 200 }}>
				<Shop />
			</div>
		{/if}

		{#if rooms}
			<div transition:slide={{ duration: 500, delay: 200 }}>
				<Rooms />
			</div>
		{/if}

		{#if season}
			<div transition:slide={{ duration: 500, delay: 200 }}>
				<Seasons />
			</div>
		{/if}

		{#if bookings}
			<div transition:slide={{ duration: 500, delay: 200 }}>
				<Bookings />
			</div>
		{/if}

		{#if revenue}
			<div transition:slide={{ duration: 500, delay: 200 }}>
				<Revenue />
			</div>
		{/if}
	</div>
{/if}

<style>
	.container {
		width: 100vw;
		height: 200vh;
		display: flex;
		flex-direction: column;
		background-color: var(--bg);
	}

	.admin {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		height: var(--navHeight);
		color: var(--colorMain);
		font-size: var(--fsL);
		font-weight: bold;
		padding-left: 20px;
		background-color: var(--bg);
	}

	.storage {
		font-size: var(--fsN);
		color: var(--colorStorage);
		margin-left: 25px;
		width: 300px;
	}

	.admin_menu {
		display: flex;
		background-color: lightslategrey;
		padding: 20px;
	}

	.admin_link {
		font-size: var(--fsN);
		color: antiquewhite;
		margin: 0 2% 0 2%;
		cursor: pointer;
	}

	.admin_link:hover {
		color: blue;
	}

	.hamburger_icon {
		background-image: url('/images/hamburger.png');
		background-size: cover;
		cursor: pointer;
		width: var(--icon);
		height: var(--icon);
		margin-right: 20px;
	}

	.hamburger_link {
		display: flex;
		justify-content: flex-end;
		border-bottom: 1px solid white;
		color: var(--colorMain);
		font-size: var(--fsS);
		padding: 10px;
		width: 100%;
		cursor: pointer;
	}

	.hamburger_menu {
		position: absolute;
		left: 0px;
		top: var(--navHeight);
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		height: fit-content;
		width: 100%;
		padding: 10px;
		background: var(--bgLight);
		font-size: var(--fsS);
		z-index: 20;
	}
</style>
